
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { ProductSelect } from '@features/onboarding/containers';
import { GetStartedLayout } from '@features/onboarding/layout';
import { AppPage } from '@shared/layout/core';
const GetStartedPage: React.FC = () => <ProductSelect />;
const __Next_Translate__Page__1a1843274d3__ = AppPage(GetStartedPage, {
    getLayout: (page) => (<GetStartedLayout centerContent={false}>{page}</GetStartedLayout>)
});

    export default __appWithI18n(__Next_Translate__Page__1a1843274d3__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  